import React from 'react';
import { useReveal } from '../lib/useReveal';
const HOTMART = 'https://checkout.recursostop.shop/cart/45770493690052:1';
const BONUSES = [{
  number: 1,
  title: 'Libro de Trabajo de Reiki',
  desc: 'Ejercicios prácticos para integrar lo aprendido.',
  image: 'https://cdn.magicpatterns.com/uploads/aD3Rzvz9ZP5RFRn4kDkGzt/ChatGPT_Image_5_feb_2026,_16_27_39.png'
}, {
  number: 2,
  title: 'Guía de los 7 Chakras',
  desc: 'Emociones, bloqueos y equilibrio energético.',
  image: 'https://cdn.magicpatterns.com/uploads/sPkoe46vwtSddz9EgxNRu4/ChatGPT_Image_5_feb_2026,_16_27_43.png'
}, {
  number: 3,
  title: 'Guía de Meditación Reiki',
  desc: 'Meditaciones para profundizar tu práctica.',
  image: 'https://cdn.magicpatterns.com/uploads/5aZmLeTL5kP6YtJeo4ys2w/ChatGPT_Image_5_feb_2026,_16_48_24.png'
}];
export function BonusesSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#faf5ef] py-20 md:py-28 px-4 border-t border-amber-100/50" data-id="element-35">
      <div className="container mx-auto max-w-3xl text-center" data-id="element-36">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-37">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-3 leading-tight" data-id="element-38">
            🎁 Bonos incluidos HOY
          </h2>
          <p className="text-green-700 font-bold text-lg mb-14" data-id="element-39">
            (gratis por tiempo limitado)
          </p>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-3 gap-8 ${vis2 ? 'is-visible' : ''}`} data-id="element-40">
          {BONUSES.map((bonus, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-md border border-amber-100 flex flex-col items-center text-center" style={{
          transitionDelay: `${idx * 120}ms`
        }} data-id="element-41">
              <a href={HOTMART} target="_blank" rel="noopener noreferrer" className="block mb-5 hover:scale-105 transition-transform" data-id="element-42">
                <img src={bonus.image} alt={bonus.title} className="w-full max-w-[240px] aspect-square object-cover rounded-xl shadow-sm mx-auto" data-id="element-43" />
              </a>
              <span className="inline-block bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-3 uppercase tracking-wide" data-id="element-44">
                Bono #{bonus.number} — Gratis
              </span>
              <h3 className="text-lg font-serif font-bold text-gray-900 mb-1" data-id="element-45">
                {bonus.title}
              </h3>
              <p className="text-gray-500 text-sm" data-id="element-46">{bonus.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}